import React from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { withLocalize } from "react-localize-redux";
import { Prompt } from 'react-router-dom';
import { Link } from 'react-router-dom';
//action
import { fetchQuaterlyReport, updateQuaterlyReport, validate } from '../../actions/quaterlyReport';
//library import
import _ from 'lodash';
//library import mantine
import { Grid } from '@mantine/core';
import { Box, ActionIcon,Affix, Overlay} from '@mantine/core';
import { Textarea } from '@mantine/core';
import { Button } from '@mantine/core';
import { Divider } from '@mantine/core';
import { Text, Paper, Space } from '@mantine/core';
import { Center } from '@mantine/core';
import { Table } from '@mantine/core';
import { Checkbox } from '@mantine/core';
import { Slider } from '@mantine/core';
//icons 
import { IconSquareRoundedX } from '@tabler/icons';
import { IconCheck } from '@tabler/icons';
import { IconX, IconStar, IconStarHalf, IconStars } from '@tabler/icons';
import { IconFileUpload, IconWand, IconChecklist, IconChecks, IconTrashX } from '@tabler/icons';
//component import
import AddButton from '../partials/AddButton';
import { InputDate, InputMonth } from '../input/InputDate.tsx';
import { InputText } from '../input/InputText.tsx';
import { Slider as CustomSlider } from '../input/Slider.tsx';
import { TextAreaLabeledStatic } from '../input/TextAreaLabeled.tsx';


const buttonStyles = {
    backgroundColor: '#eb4f1e',
};

class FormContainer extends React.Component {
    
    constructor(props) {
        super(props);
        const thisId = this.props.match.params.id;
        this.props.fetchQuaterlyReport(thisId);
        this.state = {
            inputValues: {
                title: new Date(),
                presentation: {
                    context:"",
                    manager:"",
                    consultant:"",
                    client:"",
                    clientManager:"",
                    site:"",
                    address:""
                },
                technicalMeans: "",
                presentationDeliverables: "",
                needs:{pdp:"",epi:"",hse:"",informations:""},
                activities: [
                    {
                        name: "",
                        tasks: [{
                            name:"",
                            description: "",
                            deliveryDateExpected: new Date(),
                            deliveryDateActual: new Date(),
                            progression: 0,
                            result: ""
                        }]
                    }],
                problems:"",
                actions: [{
                    actions:"",
                    deadline:new Date(),
                    pilot:"",
                    dueDate:new Date()
                }],
                recommandations:"",
                appreciation:{
                    client:[ [false,false,false,false], [false,false,false,false], [false,false,false,false], [false,false,false,false] ],
                    ikos:[ [false,false,false,false], [false,false,false,false], [false,false,false,false], [false,false,false,false] ]
                },
                glossary:""
            },
            dataWasChanged:false,
            wasAutofield:false,
            isPopupOpen: false
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isLoading === true && this.props.isLoading === false){

            let content = this.props.quaterlyReport.content

            const activities = content.activities.map((activity) => {
                return {
                    ...activity,
                    tasks: activity.tasks.map((task) => {
                        return {...task,
                            deliveryDateExpected: new Date(Date.parse(task.deliveryDateExpected)),
                            deliveryDateActual: new Date(Date.parse(task.deliveryDateActual))
                        }
                    })
                }
            })

            const actions = content.actions.map((action) => {
                return {
                    ...action,
                    deadline: new Date(Date.parse(action.deadline)),
                    dueDate: new Date(Date.parse(action.dueDate))
                }
            })

            this.setState((prevState) => ({
                inputValues: {
                  ...prevState.inputValues,
                  title: new Date(Date.parse(content.title)),
                  glossary: content.glossary,
                  presentation: content.presentation,
                  technicalMeans: content.technicalMeans,
                  presentationDeliverables : content.presentationDeliverables,
                  activities : activities,
                  actions : actions,
                  needs : content.needs,
                  problems: content.problems,
                  recommandations: content.recommandations,
                  appreciation: content.appreciation
                },
            }));
        } 
    }

    togglePopup() {
        if (this.state.isPopupOpen) {
          this.setState({ isPopupOpen: false })
        }
        else {
          this.setState({ isPopupOpen: true })
        }
    }

    handleAddProject = () => {
        const { inputValues } = this.state;
        const newElement = [{
            deliverables: "",
            dueDate1: new Date(),
            dueDate2: new Date(),
            avancement: 0,
            analysis: ""
        }];
        const handleAddDeliverable = inputValues.deliverablesPackages;
        const updatedDeliverablesPackages = [...handleAddDeliverable, newElement];
        const updatedInputValues = {
            ...inputValues,
            deliverablesPackages: updatedDeliverablesPackages
        };
        this.setState({ inputValues: updatedInputValues });
    };

    handleAddElement = (index) => {
        const { inputValues } = this.state;
        const newElement = {
            deliverables: "",
            dueDate1: new Date(),
            dueDate2: new Date(),
            avancement: 0,
            analysis: ""
        };
        const handleAddDeliverable = inputValues.deliverablesPackages[index];
        const updatedDeliverablesPackages = [...handleAddDeliverable, newElement];
        const updatedInputValues = {
            ...inputValues,
            deliverablesPackages: inputValues.deliverablesPackages.map((arr, i) => (i === index ? updatedDeliverablesPackages : arr))
        };
        this.setState({ inputValues: updatedInputValues });
    };
    

    handleAddElementActionPlans = () => {
        const { inputValues } = this.state;
        const newElement = {
            actions:"",
            deadline:new Date(),
            pilot:"",
            dueDate:new Date()
        };
        const updatedNewData = [...inputValues.actions, newElement];
        const updatedInputValues = {
            ...inputValues,
            actions: updatedNewData
        };
        this.setState({ inputValues: updatedInputValues });
    };


    //do the opposite of handleAddElement by removing an element of list of project
    handleRemoveElement = (indexToDelete,parent,indexParrent) => {
        if(indexParrent !== undefined){
            if (this.state.inputValues[parent][indexParrent].length > 1) {
                const { inputValues } = this.state;
                const updatedDeliverablesPackages = [...inputValues[parent]];
                let updatedDeliverablesPackagesChild = [...inputValues[parent][indexParrent]]
                if (0 <= indexToDelete && indexToDelete < updatedDeliverablesPackagesChild.length) {
                    updatedDeliverablesPackagesChild.splice(indexToDelete, 1);
                }
                let finalProj = updatedDeliverablesPackages
                finalProj[indexParrent] = updatedDeliverablesPackagesChild
                const updatedInputValues = {
                    ...inputValues,
                    [parent]: finalProj
                };
                this.setState({ inputValues: updatedInputValues });
            }
        }
        if(this.state.inputValues[parent].length>1 && indexParrent === undefined){
            const { inputValues } = this.state;
            const updatedDeliverablesPackages = [...inputValues[parent]];
            if (0 <= indexToDelete && indexToDelete < updatedDeliverablesPackages.length) {
                updatedDeliverablesPackages.splice(indexToDelete, 1);
            }
            const updatedInputValues = {
                ...inputValues,
                [parent]: updatedDeliverablesPackages
            };
            this.setState({ inputValues: updatedInputValues });
        }
    };


    removeTaskHandlerFactory(index){
        function removeHandlerFactory(j){
            function removeHandler(){
                this.setState(prevState => ({
                    ...prevState, inputValues: {
                        ...prevState.inputValues,
                    activities: prevState.inputValues.activities.map((activity, i) =>
                      i === index
                        ? {
                            ...activity,
                            tasks: activity.tasks.filter((_, taskIndex) => taskIndex !== j)
                          }
                        : activity
                    )
            }}));
            }
            return removeHandler.bind(this)
        }
        return removeHandlerFactory.bind(this)
    }


    updateTaskHandlerFactory(activityIndex,taskIndex,key){
        function updateTaskHandler(value){
            
            this.setState(prevState => ({
                ...prevState, inputValues: {
                    ...prevState.inputValues,
                    activities: prevState.inputValues.activities.map((activity, i) =>
                        i === activityIndex
                            ? {
                                ...activity,
                                tasks: activity.tasks.map((task, j) =>
                                    j === taskIndex
                                        ? { ...task, [key]: value }
                                        : task
                                )
                            }
                            : activity
                    )
                }

            }));
        }
        return updateTaskHandler.bind(this)
    }

    addTaskHandlerFactory(activityIndex){
        function updateTaskHandler(){
            
            this.setState(prevState => ({
                ...prevState, inputValues: {
                    ...prevState.inputValues,
                    activities: prevState.inputValues.activities.map((activity, i) =>
                        i === activityIndex
                            ? {
                                ...activity,
                                tasks: [...activity.tasks,{
                                    name:"",
                                    description: "",
                                    deliveryDateExpected: new Date(),
                                    deliveryDateActual: new Date(),
                                    progression: 0,
                                    result: ""
                                }]
                            }
                            : activity
                    )
                }

            }));
        }
        return updateTaskHandler.bind(this)
    }

    removeActivityHandlerFactory(activityIndex){
        function removeHandler(){
            this.setState(prevState => ({
                ...prevState, inputValues: {
                    ...prevState.inputValues,
                activities: prevState.inputValues.activities.filter((_, i) => i !== activityIndex)
        }}));
        }
        return removeHandler.bind(this)
    }


    updateActivityHandlerFactory(activityIndex,key){
        function updateTaskHandler(value){
            
            this.setState(prevState => ({
                ...prevState, inputValues: {
                    ...prevState.inputValues,
                    activities: prevState.inputValues.activities.map((activity, i) =>
                        i === activityIndex
                            ? {
                                ...activity,
                                [key] : value
                            }
                            : activity
                    )
                }

            }));
        }
        return updateTaskHandler.bind(this)
    }

    addActivityHandlerFactory(){
        function updateTaskHandler() {

            this.setState(prevState => ({
                ...prevState, inputValues: {
                    ...prevState.inputValues,
                    activities: [...prevState.inputValues.activities,
                    {
                        name: "",
                        tasks: [{
                            name: "",
                            description: "",
                            deliveryDateExpected: new Date(),
                            deliveryDateActual: new Date(),
                            progression: 0,
                            result: ""
                        }]
                    }]
                }

            }));
        }
        return updateTaskHandler.bind(this)
    }


    renderActivities(){
        return (
            <div className='formulaire'>
                {this.state.inputValues.activities.map((activity, i) => {return this.renderActivity(activity, i)})}
                <div key={`add-activity`} className="duplicate" onClick={this.addActivityHandlerFactory()}>
                    <AddButton />
                </div>
            </div>
        )
    }

    renderActivity(activity,i){
        const fields = activity.tasks.map((task,j) => {
            return {
                name: {value: this.state.inputValues.activities[i].tasks[j].name, setter: this.updateTaskHandlerFactory(i,j,"name")},
                description: {value: this.state.inputValues.activities[i].tasks[j].description, setter: this.updateTaskHandlerFactory(i,j,"description")},
                deliveryDateExpected: {value: this.state.inputValues.activities[i].tasks[j].deliveryDateExpected, setter: this.updateTaskHandlerFactory(i,j,"deliveryDateExpected")},
                deliveryDateActual: {value: this.state.inputValues.activities[i].tasks[j].deliveryDateActual, setter: this.updateTaskHandlerFactory(i,j,"deliveryDateActual")},
                progression: {value: this.state.inputValues.activities[i].tasks[j].progression, setter: this.updateTaskHandlerFactory(i,j,"progression")},
                result: {value: this.state.inputValues.activities[i].tasks[j].result, setter: this.updateTaskHandlerFactory(i,j,"result")}
            }
        })
        const onChangeHandler = this.updateActivityHandlerFactory(i,'name')
        return (
            <div  >
                <div className="button-bar">
                    <InputText
                        onChange={(e) => { onChangeHandler(e.target.value) }}
                        placeholder={"Nom de l'activite"}
                        value={activity.name}
                        name={'custom-title'}
                        isRequired={false}
                    />
                    <div className="delete-part" style={{ borderRadius: "5px 5px 0px 0px" }} onClick={this.removeActivityHandlerFactory(i)}>
                        <i className="fas fa-trash" style={{ color: '#ffffff' }}></i>
                    </div>
                </div>
                <div className='inbox'>
                    <TaskFields
                        value={fields}
                        index={i}
                        removeHandlerFactory={this.removeTaskHandlerFactory(i)}
                        addTaskHandler={this.addTaskHandlerFactory(i)}
                    />
                </div>
            </div>
  
        )
    }


    renderTextareas = (parent,index) => {
        let parrent = this.state.inputValues[parent]
        if(index !== undefined){parrent = this.state.inputValues[parent][index]}
        const numElements = parrent.length;
        let iconIsNotActivated = false
        if (numElements === 1) { iconIsNotActivated = true}
        const textareaRows = [];
        let row = []
        for (let i = 0; i < numElements; i++) {
            row = []
            for (const variable in parrent[i])
            {
                if(variable === "actions" || variable === "pilot"){
                    let offSet = 0
                    if(variable === "actions"){offSet = 3}else{offSet = 0}
                    row.push(
                        <Grid.Col key={variable + i} span={4+offSet}>
                            <Textarea
                                autosize
                                minRows={2}
                                radius="md"
                                placeholder={this.props.translate("quaterlyReport.view." + variable)}
                                key={i}
                                name={variable}
                                value={parrent[i][variable]}
                                onChange={(event) => this.handleInputChangeTable( event , i, variable,"event",parent)}
                            />
                        </Grid.Col>
                    )
                }
                if(variable === "deliverables" || variable === "analysis"){
                    row.push(
                        <Grid.Col key={variable + i} span={4}>
                            <Textarea
                                autosize
                                minRows={2}
                                radius="md"
                                placeholder={this.props.translate("quaterlyReport.view." + variable)}
                                key={i}
                                name={variable}
                                value={parrent[i][variable]}
                                onChange={(event) => this.handleInputChangeTable( event , i, variable,"event",parent,index)}
                            />
                        </Grid.Col>
                    )
                }
                if(variable === "dueDate1"){
                    row.push(
                        <Grid.Col key={variable + i} span={3}>
                            <Text c="dimmed">
                                {this.props.translate("quaterlyReport.view.dueDate1")}
                            </Text>
                            <InputDate 
                                onChange={(date) => this.handleInputChangeTable(date, i, "dueDate1","date",parent, index)} 
                                value={new Date( parrent[i]["dueDate1"] )}
                                classCss={"customDatePickerWidth"}
                            />
                            <Text c="dimmed">
                                {this.props.translate("quaterlyReport.view.dueDate2")}
                            </Text>
                            <InputDate 
                                onChange={(date) => this.handleInputChangeTable(date, i, "dueDate2","date",parent, index)} 
                                value={new Date( parrent[i]["dueDate2"] )}
                                classCss={"customDatePickerWidth"}
                            />
                        </Grid.Col>
                    )
                }
                if(variable === "avancement" ){
                    row.push(
                        <Grid.Col key={variable + i} span={3}>
                            <Center>
                                {parrent[i].avancement + " %"}
                            </Center>
                            <Space h="lg" />
                            <Slider       
                                color="red"
                                thumbChildren={ this.renderStarIconProgress( parrent[i].avancement ) }
                                styles={{ thumb: { borderWidth: 2, padding: 3 }  }}
                                label={null}
                                thumbSize={26}
                                marks={[
                                    { value: 20, label: '20%' },
                                    { value: 50, label: '50%' },
                                    { value: 80, label: '80%' },
                                ]}
                                radius="md" 
                                placeholder={this.props.translate("quaterlyReport.view.avancement")}
                                name="avancement"
                                value={parrent[i].avancement}
                                onChange={(newValue) => this.handleInputChangeTable(newValue, i, variable,"number",parent, index)}
                            />
                        </Grid.Col>
                    )
                }
                if(variable === "deadline"){
                    row.push(
                        <Grid.Col key={variable + i} span={3}>
                            <Text c="dimmed">
                                {this.props.translate("quaterlyReport.view.due")}
                            </Text>
                            <InputDate 
                                onChange={(date) => this.handleInputChangeTable(date, i, "deadline","date",parent)} 
                                value={new Date( parrent[i]["deadline"] )}
                                classCss={"customDatePickerWidth"}
                            />
                            <Text c="dimmed">
                                {this.props.translate("quaterlyReport.view.closure")}
                            </Text>
                            <InputDate 
                                onChange={(date) => this.handleInputChangeTable(date, i, "dueDate","date",parent)} 
                                value={new Date( parrent[i]["dueDate"] )}
                                classCss={"customDatePickerWidth"}
                            />
                        </Grid.Col>
                    )
                }
            }
            textareaRows.push(
            <React.Fragment key={i + "group"}>
                {row}
                <Grid.Col span={1}>
                    <Space h="md" />
                    <Space h="md" />
                    <div onClick={() => this.handleRemoveElement(i,parent,index)} style={{ display: "flex", alignItems: "center" }}>
                        <ActionIcon disabled={iconIsNotActivated} size={35.66} radius="xl" variant="filled" color="red" aria-label="Settings" style={{ marginRight: "10px" }}>
                            <IconTrashX style={{ width: "100%", height: "100%", transform: "scale(0.9)" }} stroke={1.5} />
                        </ActionIcon>
                    </div>
                </Grid.Col>
                <Grid.Col span={15}>
                    <Divider my="sm" />
                </Grid.Col>
            </React.Fragment>);
        }
        return textareaRows;
    };

    /*because the goal of this page is to optimized process by only sending one request to serveur
    at the start and at the end when form is finish, we can't call backend for updating progress
    so we create in the front a function for the client to see actual progress
    the back end do not use this result, and use it own result of calculateProgress to know progress
    */
    calculateProgress(){
        let total = 0
        const content = this.state.inputValues
        const bigBlocProgressValue = 12.5
        const smallBlocProgressValue = 6.25

        _.forEach(content, function( value ){
            
            if(value.length>=50){
                total = total + bigBlocProgressValue
            }
        })
        // --- every special case are check here ---
        if(content.presentation.context.length>=50){
            total = total + bigBlocProgressValue
        }
        let projectValue = 0
        _.forEach(content.deliverablesPackages, function( project ){
            _.forEach(project, function( value ){
                if(value.length>=11){
                    projectValue = projectValue + smallBlocProgressValue
                }
            })
        })
        if(projectValue > 25){projectValue = 25;}
        total = total + projectValue;
        let appreciationProgress = 0;
        const appreciationIkos = content.appreciation.ikos;
        for (const row of appreciationIkos) {
            for (const value of row) {
                if (value === true) {
                    appreciationProgress = appreciationProgress + 3.125 ;
                }
            }
        }
        total = total + appreciationProgress;
        // --- if need it we round it up ---
        if(total>100){total = 100} 
        return(total)
    }


    updateFieldChange = () => {
        let _this = this
        const progress = this.calculateProgress();
        _this.props.updateQuaterlyReport({ ..._this.state.inputValues, progress }, _this.props.match.params.id);
    }


    handleDescription(value,seuil){
        if(seuil){
            let color = ""
            if(value >= seuil){ color = ("#199619") } 
            else { color = ("#FF6962") }
            return(
                <>
                {this.props.translate("quaterlyReport.view.label1") + " "} ( 
                <span style={{ color: color }}>
                    {value}/{seuil}
                </span>
                ) {this.props.translate("quaterlyReport.view.label2") + " "}
                </>
            )
        } else {
            return(null)
        }
    }

    handleInputChange = (event) => {
        const { name, value } = event.target;
        this.setState((prevState) => ({
          inputValues: {
            ...prevState.inputValues,
            [name]: value
          },
        }));
        this.setState({ dataWasChanged: true })
    };

    handleInputChangeArray(e, key) {
        const { value } = e.target;
        this.setState((prevState) => ({
            inputValues: {
                ...prevState.inputValues,
                needs: {
                    ...prevState.inputValues.needs,
                    [key]: value
                }
            }
        }));
    }

    handleInputChangeDate = (data, name) => {
        const value = data;
        this.setState((prevState) => ({
          inputValues: {
            ...prevState.inputValues,
            [name]: value
          },
        }));
        this.setState({ dataWasChanged: true })
    };


    handleInputChangePresentation = (event) => {
        const { name, value } = event.target;
        const { presentation } = this.state.inputValues;
        const updatedPresentation = {
            ...presentation,
            [name]: value,
        };
        this.setState((prevState) => ({
            inputValues: {
                ...prevState.inputValues,
                presentation: updatedPresentation,
            },
        }));
        this.setState({ dataWasChanged: true })
    };

    renderStarIconProgress(value){
        if(value>-1 && value<35){
            return( <IconStarHalf size={16} /> )
        }if(value>34 && value<68){
            return( <IconStar  size={16} /> )
        }if(value>67 && value<101){
            return( <IconStars size={16} /> )
        }
    }


    handleInputChangeTable = (data, index, variableName, type, parent,i) => {
        let value;
        if (type === "event") { 
            value = data.target.value;
        } else {
            value = data;
        }
        let parrent = this.state.inputValues[parent];
        if(i !== undefined){ parrent = this.state.inputValues[parent][i] }
        const updatedArray = [...parrent];
        updatedArray[index][variableName] = value;
        const updatedInputValues = {
            ...this.state.inputValues,
            [parrent]: updatedArray,
        };
        this.setState({
            inputValues: updatedInputValues,
            dataWasChanged: true,
        });
    };
    
    
    


    handleInputChangeGraph = (event) => {
        const { name, value } = event.target;
        const { presentation } = this.state.inputValues;
        const updatedPresentation = {
            ...presentation,
            [name]: value,
        };
        this.setState((prevState) => ({
            inputValues: {
                ...prevState.inputValues,
                presentation: updatedPresentation,
            },
        }));
        this.setState({ dataWasChanged: true })
    };


    handleDocumentValidation = (obj) => {
        this.props.validate(this.props.match.params.id);
    }


    getCheckboxValue(target,x,y){
        if(this.state.inputValues.appreciation[target].length>0){
            return ( this.state.inputValues.appreciation[target][x][y] )
        } else {
            return (false)
        }
    }


    handleCheckboxClick = (target ,x, y) => {
        let updatedClient = [...this.state.inputValues.appreciation[target]];
        updatedClient[x][y] = !updatedClient[x][y];
        for (let i = 0; i<4; i++){
            if(i !== y) {
                updatedClient[x][i] = false
            }
        }
        this.setState({ client: updatedClient });
    };



    renderCheckbox(target, x, y) {
        const state = this.getCheckboxValue(target, x, y);
        const CheckboxIcon = ({ indeterminate, ...others }) => {
          const opacity = state ? 1 : 0.1;
          const IconComponent = indeterminate ? IconX : IconCheck;
          return (
                <IconComponent style={{ opacity: opacity}} {...others} />
          );
        };
      
        return (
          <div>
            <Checkbox
              onChange={() => this.handleCheckboxClick(target, x, y)}
              checked={state}
              color="lime.4"
              icon={CheckboxIcon}
              indeterminate={!state}
              size="md"
            />
          </div>
        );
    }

    renderRows = (target) => {
        let themes = []
        if(target === "client"){
            themes = [
            <>{this.props.translate("quaterlyReport.appreciation.table1")}<Space h={21} /></>,
            <>{this.props.translate("quaterlyReport.appreciation.table2")}</>,
            <>{this.props.translate("quaterlyReport.appreciation.table3")}<Space h={21} /></>,
            <>{this.props.translate("quaterlyReport.appreciation.table4")}</>]
        } else {
            themes = [
            <>{this.props.translate("quaterlyReport.appreciation.table5")}</>,
            <>{this.props.translate("quaterlyReport.appreciation.table6")}</>,
            <>{this.props.translate("quaterlyReport.appreciation.table7")}</>,
            <>{this.props.translate("quaterlyReport.appreciation.table8")}</>]
        }
        let rows = []
        themes.map((element, rowIndex) => (
            rows.push(
                { themes: element, TS: this.renderCheckbox(target,rowIndex,0), S: this.renderCheckbox(target,rowIndex,1), MS:this.renderCheckbox(target,rowIndex,2), IS:this.renderCheckbox(target,rowIndex,3) },
            )
        ));
        return(rows)
    };

    renderAppreciationTable(){

        const elementsClient = this.renderRows("client")
        const elementsIkos = this.renderRows("ikos")

        const rowsClient = elementsClient.map((element,i) => (
            <tr key={i}>
              <td>{element.themes}</td>
              <td>{element.TS}</td>
              <td>{element.S}</td>
              <td>{element.MS}</td>
              <td>{element.IS}</td>
            </tr>
        ));

        const rowsIkos = elementsIkos.map((element,i) => (
            <tr key={i}>
              <td>{element.themes}</td>
              <td>{element.TS}</td>
              <td>{element.S}</td>
              <td>{element.MS}</td>
              <td>{element.IS}</td>
            </tr>
        ));

        return (
            <div>
                <Grid>
                    <Grid.Col span={6}>
                        {this.props.translate("quaterlyReport.appreciation.CLIENT")}
                        <Space h="xs" />
                        <Table striped highlightOnHover withBorder withColumnBorders >
                            <thead>
                                <tr>
                                <th>{this.props.translate("quaterlyReport.appreciation.THEMES")}</th>
                                <th>{this.props.translate("quaterlyReport.appreciation.TS")}</th>
                                <th>{this.props.translate("quaterlyReport.appreciation.S")}</th>
                                <th>{this.props.translate("quaterlyReport.appreciation.MS")}</th>
                                <th>{this.props.translate("quaterlyReport.appreciation.IS")}</th>
                                </tr>
                            </thead>
                            <tbody>{rowsClient}</tbody>
                        </Table>
                    </Grid.Col>
                    <Grid.Col span={6}>
                        IKOS
                        <Space h="xs" />
                        <Table style={{ whiteSpace: 'pre-line' }} striped highlightOnHover withBorder withColumnBorders >
                            <thead>
                                <tr>
                                <th>{this.props.translate("quaterlyReport.appreciation.THEMES")}</th>
                                <th>{this.props.translate("quaterlyReport.appreciation.TS")}</th>
                                <th>{this.props.translate("quaterlyReport.appreciation.S")}</th>
                                <th>{this.props.translate("quaterlyReport.appreciation.MS")}</th>
                                <th>{this.props.translate("quaterlyReport.appreciation.IS")}</th>
                                </tr>
                            </thead>
                            <tbody>{rowsIkos}</tbody>
                        </Table>
                    </Grid.Col>
                </Grid>
            </div>
        );
    }


    renderValidate() {
        if(!localStorage.user){
            return null;
        }
        const progress = this.calculateProgress();
        
        if(progress<100){
            return(
                <Button data-disabled onClick={(event) => event.preventDefault()}>
                  {this.props.translate("quaterlyReport.view.validate")} 
                </Button>
            )
        }

        if(progress === 100 && this.state.isPopupOpen === false){
            return(
              <div className="btn-dashboard"> 
                <Button size="md" style={buttonStyles} variant="filled" onClick={() => {this.togglePopup()}}   >
                    Valider le document
                    <IconChecklist  />
                </Button>     
              </div>
            )
        }

        if(progress === 100 && this.state.isPopupOpen){
            return(
                <div>
                  <>
                    <Overlay color="#000" backgroundOpacity={0.85} style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0 }} />
                  </>
                  <Affix position={{ bottom: (window.innerHeight)/2, left: (window.innerWidth -258.28)/2 }}>
                  <div style={{position:"absolute", top:-18,right:-18}}>
                      <ActionIcon variant="filled" radius="xl" size="xl" color="red">
                      <IconSquareRoundedX onClick={ () => this.togglePopup()} style={{ width: '70%', height: '70%' }} />
                      </ActionIcon>
                  </div>
                  <Box >
                    <Paper shadow="md" radius="xl" p="xl">
                      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                          Confirmer la validation :
                      </div>
                      <Space h="xs" />
                      <Center>
                        <Button size="md" style={buttonStyles} variant="filled" onClick={() =>  {this.updateFieldChange();this.handleDocumentValidation(this);window.location.href = '/quaterlyReport/' + this.props.match.params.id}}   >
                            Validation
                            <IconChecks />
                        </Button>
                      </Center>
                    </Paper>
                  </Box>
                  </Affix>
                </div>
            )
        }
    }

    handleAutoCompletionProject(){
        /*const { inputValues } = this.state;
        const { project } = this.props.quaterlyReport;

        const updatedContext = 
        `objectives:\n${project.content.notes.objectives}
        \nDémarche:\n${project.content.notes.context}
        \nRésultats:\n${project.content.notes.activity}`;

        const updatedInputValues = { ...inputValues, presentation: { ...inputValues.presentation, context: updatedContext } };
        this.setState({ inputValues: updatedInputValues });*/
    }

    handleAutoCompletionBasedOnContext() {
        /*if (this.props.history.location.state.index === 0) {
          this.handleAutoCompletionProject();
          this.setState({ wasAutofield: true });
        } else {
          const newData = this.props.history.location.state.data;
          this.setState({ inputValues: newData, wasAutofield: true }); 
        }*/
    }


    handleSelectChange = (newValue) => {
        const selectedQuarter = newValue;
        const updatedTitle = selectedQuarter + " - " + this.state.inputValues.title.slice(-4);
        this.setState((prevState) => ({
          inputValues: {
            ...prevState.inputValues,
            title: updatedTitle,
          },
        }));
    };

    handleNumberDateChange = (newValue) => {
        if(newValue > 0 && newValue.toString().length === 4){
            const selectedDate = newValue;
            const updatedTitle = this.state.inputValues.title.slice(0,2) + " - " + selectedDate;
            this.setState((prevState) => ({
              inputValues: {
                ...prevState.inputValues,
                title: updatedTitle,
              },
            }));
        }
    };

    renderButtonAutoCompletProject() {
        const { inputValues } = this.state;
        const contextIsEmpty = inputValues.presentation.context.length === 0;
        const backgroundColor = contextIsEmpty ? 'rgba(235, 79, 30, 1)' : 'rgba(235, 79, 30, 1)';
      
        const buttonStyles = {
          backgroundColor,
          float: 'right',
          transform: 'translateY(-25%)',
          transition: 'opacity 0.5s ease-in-out', 
          opacity: contextIsEmpty ? 1 : 0.28, 
        };
      
        return (
            <Link to={{pathname:"/project/edit/"+this.props.quaterlyReport.project.id}}>
                <Button
                    size="md"
                    style={buttonStyles}
                    variant="filled"
                >
                    {this.props.translate("quaterlyReport.view.editButton")}
                    <IconWand />
                </Button>
            </Link>
        );
    }


    renderGraphOrganisation(){
        const { presentation} = this.state.inputValues;
        return(
        <div>
            {this.props.translate("quaterlyReport.context.subTitle") + " :"}
            <Space h="xs" />
            <Grid columns={6} justify="center" align="flex-start">
                <Grid.Col span={1}>
                    {this.props.translate("quaterlyReport.context.Manager") + " :"}
                </Grid.Col>
                <Grid.Col span={1}>
                    {this.props.translate("quaterlyReport.context.Consultant") + " :"}
                </Grid.Col>
                <Grid.Col span={1}>
                    {this.props.translate("quaterlyReport.context.Client") + " :"}
                </Grid.Col>
                <Grid.Col span={1}>
                    {this.props.translate("quaterlyReport.context.Interlocutor") + " :"}
                </Grid.Col>
                <Grid.Col span={1}>
                    {this.props.translate("quaterlyReport.context.Site") + " :"}
                </Grid.Col>
                <Grid.Col span={1}>
                    {this.props.translate("quaterlyReport.context.Adress") + " :"}
                </Grid.Col>
                {/*Partie 2*/}
                <Grid.Col span={1}>
                    <Textarea 
                        autosize
                        minRows={3}
                        radius="md" 
                        disabled
                        placeholder={this.props.translate("quaterlyReport.context.Manager")}
                        name="manager"
                        value={ this.props.quaterlyReport.content.presentation.manager }
                        onChange={this.handleInputChangeGraph}
                    />
                </Grid.Col>
                <Grid.Col span={1}>
                    <Textarea 
                        autosize
                        minRows={3}
                        radius="md" 
                        disabled
                        placeholder={this.props.translate("quaterlyReport.context.Consultant")}
                        name="consultant"
                        value={ this.props.quaterlyReport.documentOwnerName }
                        onChange={this.handleInputChangeGraph}
                    />
                </Grid.Col>
                <Grid.Col span={1}>
                    <Textarea 
                        autosize
                        minRows={3}
                        radius="md" 
                        disabled
                        placeholder={this.props.translate("quaterlyReport.context.Client")}
                        name="client"
                        value={ this.props.quaterlyReport.project.content.client.level_1.value }
                        onChange={this.handleInputChangeGraph}
                    />
                </Grid.Col>
                <Grid.Col span={1}>
                    <Textarea 
                        autosize
                        minRows={3}
                        radius="md" 
                        placeholder={this.props.translate("quaterlyReport.context.Interlocutor")}
                        name="clientManager"
                        value={presentation.clientManager}
                        onChange={this.handleInputChangeGraph}
                    />
                </Grid.Col>
                <Grid.Col span={1}>
                    <Textarea 
                        autosize
                        minRows={3}
                        radius="md" 
                        placeholder={this.props.translate("quaterlyReport.context.Site")}
                        name="site"
                        value={presentation.site}
                        onChange={this.handleInputChangeGraph}
                    />
                </Grid.Col>
                <Grid.Col span={1}>
                    <Textarea 
                        autosize
                        minRows={3}
                        radius="md" 
                        placeholder={this.props.translate("quaterlyReport.context.Adress")}
                        name="address"
                        value={presentation.address}
                        onChange={this.handleInputChangeGraph}
                    />
                </Grid.Col>
            </Grid>

        </div>)


    }


    renderNeeds() {
        const { needs } = this.state.inputValues;
        const needsKeys = ['pdp', 'epi', 'hse', 'informations'];
        const textareas = needsKeys.map((key) => (
            <div key={key}>
            <Space h="xs" />
            {this.props.translate(`quaterlyReport.view.section3Ccontent.${key}`)}
            <Textarea 
                key={key}
                autosize
                minRows={2}
                radius="md"
                placeholder={this.props.translate(`quaterlyReport.view.section3Ccontent.${key}`)}
                name={key}
                value={needs[key]}
                onChange={(e) => this.handleInputChangeArray(e, key)}
            />
            </div>
        ));

        return(
            <Grid>
                <Grid.Col span={10}>
                    {textareas}
                </Grid.Col>
            </Grid>
        )
    }


    renderSelectedTitle(title){
        const titleDate = new Date(title)

        const currentYear = titleDate.getFullYear();
        const currentMonth = titleDate.getMonth() + 1; 

        return(
        <>
            {currentMonth + " - " + currentYear}
        </> 
        )
    }


    
    render() {

        if (this.props.quaterlyReport === undefined || this.props.quaterlyReport.authorization === undefined) {
            return (
              <h3>Loading...</h3>
            )
        }

        if(this.props.history.location.state && this.props.history.location.state.index >=0 && this.props.quaterlyReport.project.content && this.state.wasAutofield === false){
            this.handleAutoCompletionBasedOnContext();
        }

        const { 
        problems, recommandations, glossary,
        technicalMeans, presentationDeliverables, needs,
        } = this.state.inputValues;
        

        let subtitle = ""
        if(this.props.quaterlyReport.createdAt){
            subtitle = this.props.translate("quaterlyReport.view.creationDate") + this.props.quaterlyReport.createdAt.slice(0,10)
        }


        return(
            <div>

                {/*on leave page*/}
                <Prompt
                    when={this.state.dataWasChanged}
                    message={() => 'Êtes-vous sûr de vouloir quitter cette page ? Des changements non sauvegardés ont eu lieu.'}
                />

                {/*header*/}
                <Space h="xl" />
                <Grid justify="center" align="flex-start">
                    <Grid.Col span={12}>
                        <div className="formulaires-header">
                            <h2> {this.props.translate("quaterlyReport.list.title")} : {this.renderSelectedTitle(this.state.inputValues.title)} </h2>
                            <p style={{ margin: 0, textAlign: 'center' }}> {subtitle} </p>
                            <Space h="xl" />
                            <Center>
                                <InputMonth
                                    onChange={(date) => this.handleInputChangeDate(date, "title")} 
                                    value={new Date( this.state.inputValues.title )}
                                    classCss={"customDatePickerWidth"}
                                />
                            </Center>
     
                        
                        
                        </div>
                    </Grid.Col>



                </Grid>
                
                {/*main corps*/}
                <Space h="xl" />
                <Grid>
                    <Grid.Col span={12}>
                        {/*section 1 : 1. CONTEXTE PROJET*/}
                        <div className="formulaire-header">
                            <Text fw={500} style={{color: '#52BCC2'}}>
                                {"1. " + this.props.translate("quaterlyReport.context.title")}
                            </Text>
                        </div>
                        <Space h="xs" />
                        <Paper radius="xs" p="xl">
                            A : {this.props.translate("quaterlyReport.view.section1")}
                            {this.renderButtonAutoCompletProject()}
                            <Textarea 
                                autosize
                                disabled
                                minRows={3}
                                radius="md" 
                                name="context"
                                value={this.props.quaterlyReport.project.content.notes.objectives}
                            />
                            <Space h="lg" />
                            {this.renderGraphOrganisation()}
                            <Space h="lg" />
                            B : {this.props.translate("quaterlyReport.view.section1B")}
                            <Textarea 
                                autosize
                                minRows={3}
                                radius="md"                         
                                placeholder={this.props.translate("quaterlyReport.view.section1B")}
                                name="technicalMeans"
                                value={technicalMeans}
                                onChange={this.handleInputChange}
                            />
                            <Space h="lg" />
                            C : {this.props.translate("quaterlyReport.view.section1C")}
                            <Textarea 
                                autosize
                                minRows={3}
                                radius="md" 
                                placeholder={this.props.translate("quaterlyReport.view.section1C")}
                                name="presentationDeliverables"
                                value={presentationDeliverables}
                                onChange={this.handleInputChange}
                            />
                            <Space h="lg" />
                            D : {this.props.translate("quaterlyReport.view.section1D")}
                            <Space h="xs" />
                            {this.renderNeeds()}
                        </Paper>
                        <Space h="lg" />
                            
                        {/*section 2 : PROJETS RÉALISÉS*/}
                        <div className="formulaire-header">
                            <Text fw={500} style={{color: '#52BCC2'}}>
                                2. {this.props.translate("quaterlyReport.view.section2")}
                            </Text>
                        </div>
                        <Space h="xs" />

                        <Paper radius="xs" p="xl"> 
                            <div className="formulaires">
                            <div className="formulaire-section" style={{width:"150%"}}>
                                {this.renderActivities("deliverablesPackages")}

                            </div> 
                            </div> 
                        </Paper>
                        <Space h="lg" />

                        {/*section 3 : problems TECHNIQUES RENCONTRES ET SOLUTIONS APPORTEES*/}
                        <div className="formulaire-header">
                            <Text fw={500} style={{color: '#52BCC2'}}>
                                3. {this.props.translate("quaterlyReport.view.section3bis")}
                            </Text>
                        </div>
                        <Space h="xs" />
                        <Paper radius="xs" p="xl">
                            A : {this.props.translate("quaterlyReport.view.section3A")}
                            <Textarea 
                                autosize
                                minRows={3}
                                radius="md" 
                                placeholder={this.props.translate("quaterlyReport.view.section3A")}
                                name="recommandations"
                                value={recommandations}
                                onChange={this.handleInputChange}
                            />
                            <Space h="lg" />
                            B : {this.props.translate("quaterlyReport.view.section3B")}
                                <Space h="xl"/>
                                <Grid columns={15}>
                                    <Grid.Col span={7}>
                                        <Center>
                                            {this.props.translate("quaterlyReport.view.actions")}
                                        </Center>
                                    </Grid.Col>
                                    <Grid.Col span={3}>
                                        <Center>
                                            {this.props.translate("quaterlyReport.view.due")} & {this.props.translate("quaterlyReport.view.closure")}
                                        </Center>
                                    </Grid.Col>
                                    <Grid.Col span={4}>
                                        <Center>
                                            {this.props.translate("quaterlyReport.view.pilot")}
                                        </Center>
                                    </Grid.Col>
                                    <Grid.Col span={1}>
                                        {/**delete column space */}
                                    </Grid.Col>
                                    {this.renderTextareas("actions")}
                                </Grid>
                                <Space h="md" />
                                <Grid >
                                    <Grid.Col span={3}>
                                        <div onClick={this.handleAddElementActionPlans} >
                                            <AddButton > </AddButton>
                                        </div>
                                    </Grid.Col>
                                </Grid>
                                <Space h="md" />
                            <Space h="lg" />
                            C : {this.props.translate("quaterlyReport.view.section3C")}
                            <Textarea 
                                autosize
                                minRows={3}
                                radius="md" 
                                placeholder={this.props.translate("quaterlyReport.view.section3C")}
                                name="problems"
                                value={problems}
                                onChange={this.handleInputChange}
                            />
                        </Paper>
                        <Space h="lg" />


                        {/*section 4 : Appreciation*/}
                        <div className="formulaire-header">
                            <Text fw={500} style={{color: '#52BCC2'}}>
                                4. {this.props.translate("quaterlyReport.appreciation.title")}
                            </Text>
                        </div>
                        <Space h="xs" />
                        <Paper radius="xs" p="xl">
                            {this.renderAppreciationTable()}
                            <Space h="xs" />
                            <Text fs="italic" fz="xs" c="dimmed">
                                <>{this.props.translate("quaterlyReport.appreciation.legend")}</>
                            </Text>
                        </Paper> 


                        {/*section 5 : glossary/GLOSSAIRE*/}
                        <div className="formulaire-header">
                            <Text fw={500} style={{color: '#52BCC2'}}>
                                5. {this.props.translate("quaterlyReport.view.section7")}
                            </Text>
                        </div>
                        <Space h="xs" />
                        <Paper radius="xs" p="xl">
                            <Textarea 
                                autosize
                                minRows={3}
                                radius="md" 
                                placeholder={this.props.translate("quaterlyReport.view.section7")} 
                                name="glossary"
                                value={glossary}
                                onChange={this.handleInputChange}/>
                        </Paper>     
                    </Grid.Col>
                </Grid>
                <Space h="xl" />
                <Center>
                    <Text fw={500} style={{color: '#52BCC2'}}>
                        {this.calculateProgress() + "% " + this.props.translate("quaterlyReport.view.completed")}
                    </Text>
                </Center>
                <Space h="md" />
                <Center>


                    <Button size="md" style={buttonStyles} variant="filled" onClick={() => {this.updateFieldChange();window.location.href = '/quaterlyReport/' + this.props.match.params.id;}}   >
                        {this.props.translate("quaterlyReport.view.saveButton")}
                        <IconFileUpload  />
                    </Button>



                </Center>
                <Space h="md" />
                <Center>
                    {/* {this.renderValidate()} */}
                </Center>                
                <Space h="xl" />
            </div>
        )
    }
}



class ActivityFields extends React.Component {

    
    render() {
        
    return (
        null
    )
  }

}

class ActivityField extends React.Component {


    shouldComponentUpdate(nextProps, nextState) {

        return true;
    }


    render() {

      return (
        null
      )
  }

}


class TaskFields extends React.Component {


    render() {

        return (
            <>
                {this.props.value.map((content, i) => {
                    return (
                        <TaskField
                            key={`Task-field-${this.props.index}-${i}`}
                            value={content}
                            options={[]}
                            removeHandler={this.props.removeHandlerFactory(i)}
                            translate={this.props.translate}
                        />
                    )
                })}
                <div key={`add-task-${this.props.index}`} className="duplicate" onClick={this.props.addTaskHandler}>
                    <AddButton />
                </div>
            </>
        )
    }

}

class TaskField extends React.Component {

    constructor(props) {
        super(props);
    }
    

    shouldComponentUpdate(nextProps, nextState) {
        return true;
    }


    render() {
        
        const sliderOption = [
            { value: 0, label: '0%' },
            { value: 1, label: '20%' },
            { value: 2, label: '40%' },
            { value: 3, label: '60%' },
            { value: 4, label: '80%' },
            { value: 5, label: '100%' },
        ];
        
        //task.name.setter
        //task.name.value
        //handleRemove
        //task.deliveryDateExpected.value
        //task.deliveryDateExpected.setter
        //task.deliveryDateActual.value
        //task.deliveryDateActual.setter
        //task.progression.value
        //task.progression.setter
        //task.description.value
        //task.description.setter
        //task.result.value
        //task.result.setter
        
      return (
          <>
              <InputText
                  onChange={(e)=>{this.props.value.name.setter(e.target.value)}}
                  placeholder={"Nom de la tache"}
                  value={this.props.value.name.value}
                  name={'custom-title'}
                  isRequired={false}
              />
              <div key={'separator'} className="separator" style={{ margin: "0 0" }}>
                  <div className="delete-part" onClick={this.props.removeHandler}>
                      <i className="fas fa-trash" style={{ color: '#ffffff' }}></i>
                  </div>
              </div>
              <div className="button-bar" style={{ marginInline: "10px" }}>
                  <div style={{ display: "inline-block", width: "120px" }}>
                      <p style={{ fontSize: "14px", color: 'black', textAlign: 'center' }}>Echeance prevue</p>
                      <InputDate
                          onChange={(e)=>{this.props.value.deliveryDateExpected.setter(e)}}
                          value={this.props.value.deliveryDateExpected.value}
                      />
                  </div>
                  <div style={{ display: "inline-block", width: "120px" }}>
                      <p style={{ fontSize: "14px", color: 'black', textAlign: 'center' }}>Echeance realisee</p>
                      <InputDate
                          onChange={(e)=>{this.props.value.deliveryDateActual.setter(e)}}
                          value={this.props.value.deliveryDateActual.value}
                      />
                  </div>
                  <div style={{ display: "inline-block", width: "120px", marginInline: "10px" }}>
                      <p style={{ fontSize: "14px", color: 'black', textAlign: 'center' }}>Progression</p>
                      <CustomSlider
                          sliderOption={sliderOption}
                          value={Math.round(this.props.value.progression.value/20)}
                          onChangeEnd={(e)=>{this.props.value.progression.setter(e*20)}}
                      />
                  </div>
              </div>
              <div className={"formulaire-field textarea"}>
                  <TextAreaLabeledStatic
                      onChange={(e)=>{this.props.value.description.setter(e.target.value)}}
                      name={'description'}
                      value={this.props.value.description.value}
                      label={{ title: "Livrables & activite avec descriptif" }}
                      maxLength={300}
                      height={'100px'}
                  />
              </div>
              <div className={"formulaire-field textarea"}>
                  <TextAreaLabeledStatic
                      onChange={(e)=>{this.props.value.result.setter(e.target.value)}}
                      name={'analysis'}
                      value={this.props.value.result.value}
                      label={{ title: "Analyses des resultats" }}
                      maxLength={300}
                      height={'100px'}
                  />
              </div>
          </>
      )
  }

}




const mapStateToProps = state => (    
    {
    quaterlyReport: state.quaterlyReport.quaterlyReport,
    message: state.project.message,
    isLoading: state.document.isLoading,
})

const mapDispatchToProps = dispatch => bindActionCreators({
    fetchQuaterlyReport,
    updateQuaterlyReport,
    validate,
}, dispatch);


export default withRouter(connect(mapStateToProps,mapDispatchToProps,null)(withLocalize(FormContainer)));
